import Avatar from 'components/base/Avatar';
import React from 'react';
import { Card } from 'react-bootstrap';
import user from 'assets/img/profile/profileImage.jpg';
import { Props } from './acquisitionsProfileCard.type';

const profiles = [
  {
    userName: 'Michael Martinez',
    info: {
      profileImage: ''
    },
    role: {
      value: 'Product Designer'
    }
  },
  {
    userName: 'Harper Wilson',
    info: {
      profileImage: ''
    },
    role: {
      value: 'Product Designer'
    }
  },
  {
    userName: 'Amelia Williams',
    info: {
      profileImage: ''
    },
    role: {
      value: 'Product Designer'
    }
  },
  {
    userName: 'Kaira Martin',
    info: {
      profileImage: ''
    },
    role: {
      value: 'Product Designer'
    }
  }
];

const CardItem = ({
  name,
  role,
  profile
}: {
  name: string;
  role: string;
  profile: string;
}) => {
  return (
    <div className="d-flex gap-3 mb-3 align-items-center">
      <Avatar src={profile || user} size="xl" />
      <div>
        <p className="m-0 text-body-tertiary">{name}</p>
        <small>{role}</small>
      </div>
    </div>
  );
};

function AcquisitionsProfileCard({ data }: Props) {
  return (
    <Card>
      <Card.Body>
        <header className="d-flex justify-content-between mb-3">
          <h4 className="text-body-tertiary">Acquisitions</h4>
          <small className="text-primary fw-bold">This Month</small>
        </header>
        <div>
          {Array.isArray(data) && data.length > 0 ? (
            profiles.map(
              ({ userName, info: { profileImage }, role: { value } }, idx) => (
                <CardItem
                  key={idx}
                  name={userName}
                  profile={profileImage}
                  role={value}
                />
              )
            )
          ) : (
            <div className="text-center">No entries yet</div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default AcquisitionsProfileCard;
